import { render, staticRenderFns } from "./Cart.vue?vue&type=template&id=2e7c135a&scoped=true"
import script from "./Cart.vue?vue&type=script&lang=ts"
export * from "./Cart.vue?vue&type=script&lang=ts"
import style0 from "./Cart.vue?vue&type=style&index=0&id=2e7c135a&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e7c135a",
  null
  
)

export default component.exports